import React from 'react';
import { FUNDING_READINESS_CATEGORIES } from '../../utils/funding/constants';

const FundingReadinessBreakdown = ({ check }) => {
  if (!check) {
    return (
      <div className="rounded-xl border border-dashed border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-6 text-sm text-[var(--fg-muted)]">
        Category breakdown appears after readiness is calculated.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {FUNDING_READINESS_CATEGORIES.map((category) => {
        const score = check[category.scoreKey] ?? 0;
        return (
          <div key={category.id} className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
            <div className="mb-2 flex items-center justify-between gap-3">
              <span className="text-sm font-medium text-[var(--fg-text)]">{category.label}</span>
              <span className="text-sm font-semibold text-[var(--fg-accent)]">{score}%</span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-white dark:bg-[rgba(11,31,24,0.65)]">
              <div
                className="h-full rounded-full bg-[var(--fg-accent)] transition-all"
                style={{ width: `${Math.max(0, Math.min(100, score))}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FundingReadinessBreakdown;
